import { render, staticRenderFns } from "./communityactivityreport.vue?vue&type=template&id=464e7f52&"
import script from "./communityactivityreport.vue?vue&type=script&lang=js&"
export * from "./communityactivityreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports